import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DrawCollapseDirectiveSharedModule } from '@shared/core/directives/drawCollapse/draw-collapse.directive.shared.module';
import { ImagePreloadDirectiveSharedModule } from '@shared/core/directives/imagePreload/image-preload.directive.shared.module';
import { ProjectionModule } from '@shared/core/components/projection';
import { SearchForLocationsHeroModule } from '@shared/core/components/search/searchTypes/forLocationsHero';
import { HeadersModule } from '@shared/core/components/headers';
import { PickupForHeroModule } from '@shared/core/components/pickup/pickupTypes/forHero';
import { LoyaltyHeroHeaderModule } from '@shared/core/modules/loyalty/components/loyaltyHeroHeader';
import { LocationsHeroHeaderModule } from '@shared/core/modules/locations/components/locationsHeroHeader';
import { AccountMemberHeroHeaderModule } from '@shared/core/modules/account/components/accountMemberHeroHeader';
import { OrderConfirmationHeroHeaderModule } from '@shared/core/modules/order/components/orderConfirmationHeroHeader';

import { BgOverlayModule } from '@shared/core/components/bgOverlay';
import { BgGradientModule } from '@shared/core/components/bgGradient';

import { HeroBackgroundComponent } from './hero-background.shared.component';

@NgModule({
    declarations: [
        HeroBackgroundComponent,
    ],
    imports: [
        CommonModule,
        AccountMemberHeroHeaderModule,
        LoyaltyHeroHeaderModule,
        LocationsHeroHeaderModule,
        ProjectionModule,
        HeadersModule,
        ImagePreloadDirectiveSharedModule,
        SearchForLocationsHeroModule,
        PickupForHeroModule,
        OrderConfirmationHeroHeaderModule,
        DrawCollapseDirectiveSharedModule,
        BgOverlayModule,
        BgGradientModule,
    ],
    exports: [
        HeroBackgroundComponent,
    ],
})
export class HeroBackgroundModule { }
